export const REQUEST = 'RespondentBases/Addresses/REQUEST';
export const SUCCESS = 'RespondentBases/Addresses/SUCCESS';
export const ERROR = 'RespondentBases/Addresses/ERROR';

export const SET = 'RespondentBases/Addresses/SET';
export const ADDED = 'RespondentBases/Addresses/ADDED';
export const DELETED = 'RespondentBases/Addresses/DELETED';
export const UPDATED = 'RespondentBases/Addresses/UPDATED';
